module.exports = __webpack_public_path__ + "img/sa.55a6e2d4.svg";